import { render } from "./MyTickets.vue?vue&type=template&id=6b342386"
import script from "./MyTickets.vue?vue&type=script&lang=js"
export * from "./MyTickets.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects 2022\\helmets-nepal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__